import React, {Component} from 'react';

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {
    prepareSelectOptionsList,
    actionsFormatter,
    historyDataFormatter,
    dateFormatter,
    customFormatter,
    getFieldByPathFormatter
} from 'util/Utils';

  import config from  '../../../config';


class AdminSettingsListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
            currentRecord: {},

        };

    }

    customActionsFormatter(cell, row, extra) {
        var menuItemsMap = []
        if (_.includes(['BoxSettings', 'BoxSizeSettings'], row.Name) || _.includes(row.Name,'ServiceDateRules') || _.includes(row.Name,'ServiceSettings')) {
            menuItemsMap.push({onClick: 'editRecord', label: 'Edit'})
        }

        return actionsFormatter.call(this, cell, row, {menuItemsMap})
    }

    editRecord(row) {
        this.props.editRecord(row);
    }

 








    render() {
        return (
            <div className=" databases-table">
                <BootstrapTable data={this.props.adminSettings} ref='table'
                                remote={ true }
                                hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                } }

                >
                    <TableHeaderColumn width="100px" dataAlign="center" dataField='Name'
                                       dataFormat={ customFormatter } formatExtraData={ {
                        path: ['Name'] , format: (value, arg2) => {
                            return _.startCase(value)
                        }
                    }}        dataSort={true}>Name</TableHeaderColumn>


                    {/*<TableHeaderColumn width="45px" dataAlign="center" dataField='Data'*/}
                                                                                                     {/*dataFormat={ customFormatter } formatExtraData={ {*/}
                    {/*path: ['Data'] , format: (value, arg2) => {*/}
                        {/*return JSON.stringify(value)*/}
                    {/*}*/}
                {/*}} editable={ false } dataSort={true}>Percent</TableHeaderColumn>*/}

                    <TableHeaderColumn dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                       hiddenOnInsert>Id</TableHeaderColumn>
                    <TableHeaderColumn width="20px" dataAlign="center" columnClassName={'actions-column'}
                                       editable={ false }
                                       dataFormat={ this.customActionsFormatter.bind(this) }>Actions</TableHeaderColumn>
                </BootstrapTable>

            </div>
        );
    }
}


export default AdminSettingsListTable;
